import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { RootState } from '..';

// namespace
export const CONSENT_STORE_NAMESPACE = 'consentStore';

// state
interface ConsentState {
  consent: boolean;
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: ConsentState = {
  consent: localStorage.getItem('consent') ? true : false,
  status: 'init',
};

// mutation
const mutationConstant = {
  SET: 'set',
};

const mutation: MutationTree<ConsentState> = {
  [mutationConstant.SET]: (state: ConsentState) => {
    state.consent = true;
    localStorage.setItem('consent', 'true');
  },
};

// action
const actionConstant = {
  SET: 'set',
};

const action: ActionTree<ConsentState, RootState> = {
  [actionConstant.SET](context: ActionContext<ConsentState, RootState>) {
    return new Promise<void>((resolve) => {
      context.commit(mutationConstant.SET);
      resolve();
    });
  },
};

// getter
const getterConstant = {
  GET: 'get',
};

const getter: GetterTree<ConsentState, RootState> = {
  [getterConstant.GET]: (state: ConsentState) => state.consent,
};

// module
const module: Module<ConsentState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const ConsentGetter = {
  GET: `${CONSENT_STORE_NAMESPACE}/${getterConstant.GET}`,
};

export const ConsentAction = {
  SET: `${CONSENT_STORE_NAMESPACE}/${actionConstant.SET}`,
};

export default module;
